import React from "react"
import tw, { styled } from "twin.macro"
import { graphql, useStaticQuery } from "gatsby"

import { brandRules } from "utils/brand"

const Styles = styled.div`
  ${tw`px-2 flex flex-col m:flex-row m:flex-wrap items-start justify-between overflow-hidden mx-auto max-w-s m:max-w-m l:max-w-l`}
`

const FeatureCard = styled.div`
  ${tw`my-3 flex flex-initial flex-col justify-start m:w-1/4 text-white text-center`}

  &.contact-us {
    ${tw`m:w-1/3 m:px-4`}
  }
`

const Icon = styled.div`
  ${tw`py-2 mx-auto flex flex-col justify-center`}
  height: 64px;
`

const Title = styled.h3`
  ${tw`py-2 font-display font-bold`}

  font-size: 17px;
  line-height: 16px;

  @media (min-width: 640px) {
    font-size: 20px;
    line-height: 21px;
  }

  &.contact-us {
    font-size: 15px;

    @media (min-width: 640px) {
      font-size: 15px;
    }
  }
`

const Description = styled.p`
  ${tw`font-body`}
  font-size: 14px;
  line-height: 22px;
`

const ProductionPlannerFeatures = ({ contactUs = false }) => {
  const data = useStaticQuery(graphql`
    query {
      gcms {
        contentBlocks(where: { identifier: "production-planner-features-section" }) {
          extraData
        }
      }
    }
  `)

  const { extraData } = data?.gcms?.contentBlocks?.[0]

  if (!extraData?.features) {
    return null
  }

  return (
    <Styles>
      {extraData.features.map((feature) => (
        <FeatureCard
          key={feature.title}
          className={contactUs ? "contact-us" : ""}
        >
          <Icon>
            <img src={feature.icon} alt="" width={70} height={70} />
          </Icon>
          <Title className={contactUs ? "contact-us" : ""}>
            {feature.title}
          </Title>
          <Description
            dangerouslySetInnerHTML={{
              __html: brandRules(feature.description),
            }}
          />
        </FeatureCard>
      ))}
    </Styles>
  )
}

export default ProductionPlannerFeatures
